module.exports = __webpack_public_path__ + "static/media/btn-campus-virtual.704827b2.svg";